// Shared open/close wiring for PhotosCarousel (components/PhotosCarousel.js)
// against a meal-photos list. Extracted after this exact same
// state+openCarousel+closeCarousel block had been copy-pasted 3 times —
// LogMealPhotosCard.js, TableMealPhotosPanel.js, DayDrawerPhotosCard.js —
// each with its own slightly different source shape for allPhotos/dailyStatId
// (mealPhotos.mealPhotos vs stat.mealPhotos, dailyStatId as a direct prop vs
// stat._id). Takes those two values already-computed rather than a raw
// mealPhotos/stat object, so callers keep deriving allPhotos however fits
// their own data shape — this only centralizes the carousel state and the
// /actions/refresh wiring, not the markup or the photo-list derivation.
import { useCallback, useState } from "react";
import submit from "submit-form";

export const useMealPhotosCarousel = ({ allPhotos, dailyStatId }) => {
  const [showCarousel, setShowCarousel] = useState(false);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);

  const openCarousel = useCallback(
    (photoId) => {
      const idx = allPhotos.findIndex((p) => p._id === photoId);
      const photoIndex = idx >= 0 ? idx : 0;
      setSelectedPhotoIndex(photoIndex);
      setShowCarousel(true);
      submit("/actions/refresh", { method: "GET", body: { dailyStatId, photoIndex, photoId: "" } });
    },
    [allPhotos, dailyStatId]
  );

  const closeCarousel = useCallback(() => {
    setShowCarousel(false);
    submit("/actions/refresh", { method: "GET", body: { dailyStatId: "", photoIndex: "" } });
  }, []);

  return { showCarousel, selectedPhotoIndex, setSelectedPhotoIndex, openCarousel, closeCarousel };
};
